// import { cloneDeep } from 'lodash';
import * as TYPES from './types';

const initialState = {
  list: [],
  fetching: false,
  errorMessages: null,
  errorMessagesProfile: null,
  isCreated: false,
  isDeleted: false,
  total: 0,
};
const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TYPES.GET_PROJECT_REQUEST:
    case TYPES.GET_PROJECTS_REQUEST:
    case TYPES.CREATE_PROJECT_REQUEST:
    case TYPES.EDIT_PROJECT_REQUEST:
    case TYPES.DELETE_PROJECT_REQUEST:
      return {
        ...state,
        fetching: true,
        errorFetching: false,
        isCreated: false,
        isDeleted: false,
      };

    case TYPES.GET_PROJECT_ERROR:
    case TYPES.GET_PROJECTS_ERROR:
    case TYPES.CREATE_PROJECT_ERROR:
    case TYPES.EDIT_PROJECT_ERROR:
    case TYPES.DELETE_PROJECT_ERROR:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
      };

    case TYPES.GET_PROJECTS_SUCCESS:
      return {
        ...state,
        total: payload.total,
        list: payload.projects,
        fetching: false,
      };

    case TYPES.GET_PROJECT_SUCCESS: {
      const list = [...state.list];
      let total = state.total;
      const index = list.findIndex(
        (project) => project.id_project === payload.id_project,
      );
      if (index !== -1) {
        list[index] = payload;
      } else {
        list.push(payload);
        list.sort((a, b) => a.id_project - b.id_project);
        total = total + 1;
      }
      return {
        ...state,
        total,
        list,
        fetching: false,
      };
    }

    case TYPES.EDIT_PROJECT_SUCCESS: {
      const list = [...state.list];
      let total = state.total;
      const index = list.findIndex(
        (project) => project.id_project === payload.id,
      );

      if (index !== -1) {
        list[index] = payload;
      }

      return {
        ...state,
        total,
        list,
        fetching: false,
        isCreated: true,
      };
    }

    case TYPES.CREATE_PROJECT_SUCCESS: {
      const list = [...state.list];
      let total = state.total;
      const index = list.findIndex(
        (project) => project.id_project === payload.id_project,
      );

      if (index !== -1) {
        list[index] = payload;
      } else {
        list.push(payload);
        list.sort((a, b) => a.id_project - b.id_project);
        total = total + 1;
      }
      return {
        ...state,
        total,
        list,
        fetching: false,
        isCreated: true,
      };
    }

    case TYPES.CLEAR_PROJECTS_STATE: {
      return {
        ...state,
        fetching: false,
        errorMessages: null,
        errorMessagesProfile: null,
        isCreated: false,
      };
    }

    case TYPES.DELETE_PROJECT_SUCCESS: {
      let list = [...state.list];
      list = list.filter(
        (project) => project.id_project !== parseInt(payload, 10),
      );
      return {
        ...state,
        fetching: false,
        isDeleted: true,
        list,
      };
    }

    case TYPES.CREATE_ERRORS:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
      };

    case TYPES.CLEAR_ERRORS: {
      return { ...state, errorMessages: null };
    }

    case TYPES.CLEAR_CREATE_STATE: {
      return { ...state, isCreated: false, errorMessages: null };
    }

    case TYPES.INIT_REDUCER:
      return {
        ...initialState,
        list: state.list,
        errorMessages: null,
        errorMessagesProfile: null,
      };

    default:
      return { ...state };
  }
};

export default reducer;
